(function($) {

    init()

    function init() {
        tab()
        // back()
        hamburger()
        mobileSubmenu()
        link()
        newsFilter()
        faq()
        btnParallax()
        heightImg()
        postClass()
        formCheck()
        submenu()
        stickyMenu()
        btnKom()
        whiteCursor()
        blackHoverCursorBorder()
        phoneInput()
        floatLabels()
        back()
    }

    // TAB
    function tab() {
        $(".home-customer-tabs .menu li:first-child").addClass("current");
        $(".home-customer-tabs .menu li").click(function(g) {
            var tab = $(this).closest(".home-customer-tabs"),
                index = $(this).closest("li").index();
            tab.find(".menu li").removeClass("current");
            $(this).closest("li").addClass("current");
            tab
                .find(".content")
                .find("div.content-item")
                .not("div.content-item:eq(" + index + ")")
                .hide();
            tab
                .find(".content")
                .find("div.content-item:eq(" + index + ")")
                .fadeIn();
            g.preventDefault();
        });

    }

    // BACK TOP
    function back() {
        // BUTTONS
        $(document).on('click', '#footer .footer-links-btn', function() {
            var $target = $(".navbar");
            if ($target.length) {
                $('html, body').animate({ scrollTop: $target.offset().top }, 3000);
            }
            return false
        });

        $(document).on('click', '.career-banner .btn-radius', function() {
            var $target = $("#oferty-pracy");
            if ($target.length) {
                $('html, body').animate({ scrollTop: $target.offset().top }, 750);
            }
            return false
        });

        var width = $('body').width();
        //var w = $('.blog-post ul .recommended').css({ 'margin-left': 'calc(calc(100% - ' + width + 'px) / 2)' });
    }

    function resetMobileSubmenu() {
        var $nav = $('.mobile-overlay .navbar__fixed-nav');
        $nav.find('> li').removeClass('mobile-hidden');
        $nav.find('.mobile-submenu-active').removeClass('mobile-submenu-active');
        $nav.find('.mobile-submenu-visible').removeClass('mobile-submenu-visible').hide();
        $nav.find('.mobile-back-btn').remove();
    }

    // HAMBURGER
    function hamburger() {
        $('.hamburger').on('click', function() {
            $('body, html').toggleClass('menu-open');
            // $('.mobile-overlay').stop().delay(300).toggleClass('open-m');
            $('.hamburger ').toggleClass('hamburger-active');
            if (!$('body').hasClass('menu-open')) {
                resetMobileSubmenu();
            }
        });

        $('.mobile-overlay .menu-mobile li').on("click", function() {
             $('body, html').toggleClass('menu-open');            
            $('.mobile-overlay').stop().delay(300).removeClass('open-m');
            $('.hamburger').toggleClass('hamburger-active');
        });
    }

    // LINK
    function link() {
        $("#footer .footer-col-3 p a, #footer .footer-col-2 nav ul li a, .contact-wrapper .address p a").addClass("link");
    }

    // NEWS
    function newsFilter() {
        $('.loader').hide();
        $('.blog-list-cat ul li a').on('click', function() {

            $('.blog-list-cat ul li a').removeClass('active');
            $(this).addClass('active');

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'filter_akt',
                    category: $(this).data('slug'),
                },
                beforeSend: function(res) {
                    $('.loader').show();
                },
                success: function(res) {
                    $('.loader').fadeOut();
                    $('.blog-post ul').html(res);
                }
            });
            var $blogPost = $(".blog-post");
            if ($blogPost.length) {
                $('html, body').animate({ scrollTop: $blogPost.offset().top }, 750);
            }
            return false

        });

        $('.archive-realizations-list-cat ul li a').on('click', function(e) {
            e.preventDefault();

            $('.archive-realizations-list-cat ul li a').removeClass('active');
            $(this).addClass('active');
           
            const slug = $(this).data('slug');
            const taxonomy = $(this).data('taxonomy');
            const $list = $('.list-realization');
            const $loader = $('.loader');

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'filter_real',
                    taxonomy: taxonomy,
                    slug: slug
                },
                beforeSend: function() {
                    $loader.show();
                },
                success: function(res) {
                    const html = $.trim(res);

                    $loader.fadeOut();

                    if (!html) {
                        return;
                    }

                    $list.html(html);

                    if (window.matchMedia('(max-width: 767px)').matches) {
                        $list.find('[data-aos]').addClass('aos-animate');
                    } else if (window.AOS && typeof window.AOS.refreshHard === 'function') {
                        window.AOS.refreshHard();
                    }
                },
                error: function() {
                    $loader.fadeOut();
                }
            });

            var $archiveList = $(".archive-realizations-list");
            if ($archiveList.length) {
                $('html, body').animate({ scrollTop: $archiveList.offset().top }, 750);
            }
            return false
        });
    }

    // FAQ
    function faq() {
        $('.career-job-list-loop .title').on('click', function() {
            if ($(this).closest('li').hasClass('active')) {
                $(this).closest('li').removeClass('active');
            } else {
                $('.career-job-list-loop ul li').removeClass('active');
                $(this).closest('li').addClass('active');
                $('.career-job-list-loop .a').slideUp(500);
            }
            $(this).next().slideToggle(500);
        });

        $('.services-list-row-loop ul li .title').on('click', function() {
            if ($(this).closest('li').hasClass('active')) {
                $(this).closest('li').removeClass('active');
            } else {
                $('.services-list-row-loop ul li').removeClass('active');
                $(this).closest('li').addClass('active');
                $('.services-list-row-loop .a').slideUp(500);
            }
            //$('.career-job-list-loop .a').slideUp(500);
            $(this).next().slideToggle(500);
        });

        $('.services-proces-row-loop ul li .title').on('click', function() {
            if ($(this).closest('li').hasClass('active')) {
                $(this).closest('li').removeClass('active');
            } else {
                $('.services-proces-row-loop ul li').removeClass('active');
                $(this).closest('li').addClass('active');
                $('.services-proces-row-loop .a').slideUp(500);
            }
            //$('.career-job-list-loop .a').slideUp(500);
            $(this).next().slideToggle(500);
        });

        $('.home-services ul li .title').on('click', function() {
            if ($(this).closest('li').hasClass('active')) {
                $(this).closest('li').removeClass('active');
            } else {
                $('.home-services ul li').removeClass('active');
                $(this).closest('li').addClass('active');
                $('.home-services ul li .a').slideUp(500);
            }
            //$('.career-job-list-loop .a').slideUp(500);
            $(this).next().slideToggle(500);
        });
    }

    // BUTTON PARALAX
    function btnParallax() {
        if (!window.matchMedia('(min-width: 768px)').matches) return;

        $('.parallaxed').on('mousemove', function(e) {
            const bounds = this.getBoundingClientRect();
            const centerX = bounds.left + bounds.width / 2;
            const centerY = bounds.top + bounds.height;

            const deltaX = Math.floor((centerX - e.clientX)) * 0.222;
            const deltaY = Math.floor((centerY - e.clientY)) * 0.333;

            $(this).css({
                transform: 'translate3d(' + deltaX * 0.4 + 'px, ' + deltaY * 0.4 + 'px, 0px)'
            });
        });

        $('.parallaxed').on('mouseout', function(e) {
            $(this).css({
                transform: 'translate3d(0px,0px,0px)'
            });
        });
    }

    // HEIGHT IMG
    function heightImg() {
        if ($(window).width() > 1200) {
            var h = $('.news-single-cnt-loop-image img').height();
            $('.news-single-cnt-loop-image').css({ height: `calc(${h}px - 30px)` });
        }
    }

    // POST CLASS
    function postClass() {
        $('.news-single-cnt-loop a').addClass('link-post');
        $('.news-single-cnt-loop-share a').removeClass('link-post');
    }

    // FORMCHECK
    function formCheck() {
        $('.contact-wrapper .form form .uslugi-box-header').on('click', function() {
            var header = $(this).closest('.uslugi-box-header');
            $('.uslugi-box-checkbox').slideToggle();

            // Toggle rotation on header
            header.toggleClass('rotated');
        });
    }

    // MOBILE SUBMENU
    function mobileSubmenu() {
        var $nav = $('.mobile-overlay .navbar__fixed-nav');

        $nav.on('click', '> li.dropdown > a', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var $parent = $(this).closest('li.dropdown');
            var $submenu = $parent.find('> .dropdown-menu');

            $nav.find('> li').not($parent).addClass('mobile-hidden');
            $parent.addClass('mobile-submenu-active');
            $submenu.addClass('mobile-submenu-visible').css('display', 'block');

            if (!$nav.find('.mobile-back-btn').length) {
                $nav.prepend('<li class="mobile-back-btn"><button type="button">&#8592; Wróć</button></li>');
            }
        });

        $nav.on('click', '.mobile-back-btn button', function() {
            resetMobileSubmenu();
        });

        $nav.on('click', '.mobile-submenu-visible li a', function() {
            $('body, html').removeClass('menu-open');
            $('.hamburger').removeClass('hamburger-active');
        });
    }

    // SUBMENU
    // function submenu() {
    //     $('.dropdown-menu').hide();

    //     // Obsługa hovera dla całego obszaru (przycisk + submenu)
    //     $('.menu-item.dropdown').on('mouseenter', function() {
    //         $(this).find('.dropdown-menu').stop(true, true).fadeIn().addClass('down');
    //         setTimeout(function() {
    //             $('.submenu-overlay').addClass('active');
    //         }, 200);
    //     });

    //     // $('.navbar').on('mouseleave', function () {
    //     //   $('.dropdown-menu').stop(true, true).fadeOut();
    //     // });

    //     $('.menu-item.dropdown').on('mouseleave', function() {
    //         const $menu = $(this).find('.dropdown-menu');
    //         $menu.removeClass('down'); // usuń klasę natychmiast

    //         setTimeout(function() {
    //             $menu.stop(true, true).fadeOut(); // schowaj po 1s
    //         }, 100);
    //         $('.submenu-overlay').removeClass('active');
    //     });

    //     $('.dropdown-menu a').on('click', function() {
    //         const $menu = $(this).closest('.dropdown-menu');
    //         $('.submenu-overlay').removeClass('active');
    //         $menu.stop(true, true).fadeOut();
    //     });
    // }

    // SUBMENU
function submenu() {
    $('.dropdown-menu').hide();

    let overlayTimer = null;

    // Obsługa hovera dla całego obszaru (przycisk + submenu)
    $('.menu-item.dropdown').on('mouseenter', function() {
        if ($(window).width() < 1024) return;
        if (overlayTimer) clearTimeout(overlayTimer);

        $(this).find('.dropdown-menu').stop(true, true).fadeIn().addClass('down');

        overlayTimer = setTimeout(function() {
            $('.submenu-overlay').addClass('active');
        }, 200);
    });

    $('.menu-item.dropdown').on('mouseleave', function() {
        if ($(window).width() < 1024) return;
        if (overlayTimer) clearTimeout(overlayTimer);

        const $menu = $(this).find('.dropdown-menu');
        $menu.removeClass('down');

        setTimeout(function() {
            $menu.stop(true, true).fadeOut();
        }, 100);

        $('.submenu-overlay').removeClass('active');
    });

    $('.dropdown-menu a').on('click', function() {
        if (overlayTimer) clearTimeout(overlayTimer);

        const $menu = $(this).closest('.dropdown-menu');
        $('.submenu-overlay').removeClass('active');
        if ($(window).width() >= 1024) {
            $menu.stop(true, true).fadeOut();
        }
    });
}


    // STICKY MENU
    function stickyMenu() {
        $(document).ready(function() {
            const $stickyMenu = $('.home-menu-sticky');
            const $services = $('.home-services');

            if (!$stickyMenu.length || !$services.length) return;

            $(window).on('scroll', function() {
                const scrollTop = $(window).scrollTop();
                const menuHeight = $stickyMenu.outerHeight();
                const servicesTop = $services.offset().top;

                if (scrollTop + menuHeight >= servicesTop) {
                    $stickyMenu.addClass('black');
                } else {
                    $stickyMenu.removeClass('black');
                }
            });
        });

    }

    // BTN KOMPETENCJE
    function btnKom() {
        $('.home-hero-competences a[href^="#"]').on('click', function(e) {
            const target = $(this.getAttribute('href'));
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1500); // wolniejsza animacja (1.5 sekundy)
            }
        });
    }

    function whiteCursor() {
        const whiteCursorSelectors = [
            '.contact-wrapper .form form .usluga-option', 
            '#footer .footer-black ul li a',
            '.news-image',
            '.news-single-cnt-loop-share li a',
            '.career-job-list-loop .title',
            '.career-job-info a',
            '.archive-realizations-list-cat ul li .active',
            '.archive-realizations-list ul.list-realization li a .foto',
            '.realizations-single-cnt-foto-btn .btn-radius',
            '.news-single-other ul li a .foto',
            '.services-slider-text-row .button .btn-radius',
            '.services-profit-boxes-item',
            '.services-proces-row-loop ul li .title',
            '.realizations-single-cnt-comment',
            '.home-services ul li .title',
            '.section-menu .home-menu .black ul li a',
            '.home-award-row-txt .btn-border',
            '.home-industries-title',
            '#footer .footer-black ul li a',
            '.services-list',
            '.services-proces',
            '.agency-gallery',
            '.agency-gallery-slider'
        ];
        const whiteCursorAreasExceptLinks = [
            '.home-contact',
            '.home-industries-wrapper',
            '.home-services',
            '.career-job',
            '.agency-banner',
        ];

        if (!whiteCursorSelectors.length && !whiteCursorAreasExceptLinks.length) return;

        const selector = whiteCursorSelectors.join(',');
        const areaExceptLinksSelector = whiteCursorAreasExceptLinks.join(',');

        document.addEventListener('pointermove', function(e) {
            const isInListedSelector = selector ? !!e.target.closest(selector) : false;
            const isInAreaExceptLinks = areaExceptLinksSelector ?
                !!e.target.closest(areaExceptLinksSelector) && !e.target.closest('a') :
                false;

            document.body.classList.toggle('cursor-white', isInListedSelector || isInAreaExceptLinks);
        });

        document.addEventListener('pointerleave', function() {
            document.body.classList.remove('cursor-white');
        });
    }

    function blackHoverCursorBorder() {
        const blackHoverCursorBorderSelectors = [
            '.contact-wrapper .form form .uslugi-box-header',
            '.home-customer-tabs .menu li span',
            '#footer .footer-col',
        ];

        if (!blackHoverCursorBorderSelectors.length) return;

        const selector = blackHoverCursorBorderSelectors.join(',');

        document.addEventListener('pointermove', function(e) {
            document.body.classList.toggle('cursor-hover-border-black', !!e.target.closest(selector));
        });

        document.addEventListener('pointerleave', function() {
            document.body.classList.remove('cursor-hover-border-black');
        });
    }

    function phoneInput() {
        $(document).on('input', 'input[name="form-tel"]', function() {
            this.value = this.value
                .replace(/[^\d+]/g, '')
                .replace(/(?!^)\+/g, '')
                .slice(0, 12);
        });
    }

    // FORM - placeholder przechodzi nad wpisywany tekst (floating label)
    function floatLabels() {
        $('.wpcf7 .row-form').find('input[type="text"], input[type="tel"], input[type="email"], textarea').each(function() {
            var $field = $(this);
            var text = $field.attr('placeholder');
            var $wrap = $field.closest('.wpcf7-form-control-wrap');

            if (!text || !$wrap.length || $wrap.hasClass('float-field')) return;

            if (!this.id) {
                this.id = 'float-' + this.name;
            }

            // " " zamiast tekstu - stan pola rozpoznajemy w CSS przez :placeholder-shown
            $field.attr('placeholder', ' ');
            $wrap.addClass('float-field');
            $('<label class="float-label"></label>')
                .attr('for', this.id)
                .text(text)
                .insertAfter($field);
        });
    }

    // ALL
    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
            img.src = img.dataset.src;
        });
    } else {
        // Dynamically import the LazySizes library
        const script = document.createElement('script');
        script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
        document.body.appendChild(script);
    }

    // PLACEHOLDER
    $('input,textarea').focus(function() {
        $(this).data('placeholder', $(this).attr('placeholder'))
            .attr('placeholder', '');
    }).blur(function() {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });
}(jQuery));
